const base = '/onboarding';

export const onboardingRoutes = {
  index: base,
} as const;
